var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWrongAnswerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72.325,
    height: 74.661,
    viewBox: "0 0 72.325 74.661",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 767"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 256",
    d: "M105.569 1724.594a90.29 90.29 0 0 0 6.6.635 64.993 64.993 0 0 0 12.361 0c3.432-.485 4.248-.7 4.374-1.706v-.975l-.826-.289a22.357 22.357 0 0 1-6.254-3.207c-.643-.511-.665-.931-.5-1.4a4.846 4.846 0 0 1 1.619-2.188 36.262 36.262 0 0 0 8.218-9.183 34.99 34.99 0 0 0 4.772-12.212 33.7 33.7 0 0 0-.346-13.923 35.993 35.993 0 0 0-5.476-12.246 35.4 35.4 0 0 0-9.7-9.356 35.017 35.017 0 0 0-13-5.1 33.391 33.391 0 0 0-13.923.346 36.709 36.709 0 0 0-12.271 5.428 34.67 34.67 0 0 0-14.463 22.572 33.585 33.585 0 0 0 .188 13.177 34.767 34.767 0 0 0 4.925 11.731 37 37 0 0 0 8.8 9.28 35.517 35.517 0 0 0 11.83 5.781c1.107.341 2.3.678 3.582 1s2.685.633 4.248.953q1.168.244 2.493.464c.86.143 1.787.283 2.749.418z",
    transform: "translate(-65.18 -1651.864)",
    style: {
      stroke: "#a5aab4",
      fill: "#fff",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 766"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 257",
    d: "M94.088 1694.38a8.5 8.5 0 0 1 1.5-4.769 15.579 15.579 0 0 1 3.265-3.658 20.428 20.428 0 0 0 3.265-3.265 5.986 5.986 0 0 0 1.5-3.746 3.681 3.681 0 0 0-1.363-3.068 5.991 5.991 0 0 0-3.8-1.078q-4.768 0-6.756 5.053l-6.7-3.86a13.31 13.31 0 0 1 5.428-6.5 15.523 15.523 0 0 1 8.318-2.3 14.006 14.006 0 0 1 8.943 2.982 10.656 10.656 0 0 1 2.781 12.633 13.485 13.485 0 0 1-2.385 3.493q-1.391 1.447-2.782 2.725a18.038 18.038 0 0 0-2.385 2.641 4.607 4.607 0 0 0-.995 2.726zm7.325 12.661a4.8 4.8 0 1 1 1.416-3.407 4.644 4.644 0 0 1-1.416 3.408z",
    transform: "translate(-61.795 -1649.289)",
    style: {
      fill: "#f61616",
      stroke: "#a5aab4"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrongAnswerIcon);
export default __webpack_public_path__ + "static/media/wrong-answer-icon.892605d7.svg";
export { ForwardRef as ReactComponent };